// arsenal-tpms/frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// i18n configuration
import './i18n/config';

// Import global styles
import './styles/globals.css';

// Create root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the application
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Clear old browser caches on startup if a new build was deployed
if ('caches' in window) {
  caches.keys().then((names) => {
    for (let name of names) {
      if (name.includes('arsenal-cache') || name.includes('workbox')) {
        caches.delete(name);
      }
    }
  }).catch(() => {});
}

// Service Worker para Web Push (notificaciones del chat). El registro es
// inofensivo sin sesión; la suscripción ocurre tras autenticarse.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

reportWebVitals();